import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as types from 'constants/actionTypes';
import { FormControl, TextField, FormHelperText } from '@mui/material';

const EmailInput = ({label = "", name = "", type = "text", className = "", defaultValue, errorMsg, required, onPressKey, textProps = {}, 
                    minLength, maxLength, id, startAdornment, endAdornment, hintText, ...props}) => {
    const dispatch = useDispatch();

    // Getting state from Redux store
    const { [name]: reduxValue, error: reduxErrors } = useSelector((state) => state.form) || [];
    const { [name]: reduxErrorMsg } = reduxErrors || {};
    const [localValue, setLocalValue] = useState(reduxValue || ``);
    const [localError, setLocalError] = useState(reduxErrorMsg);
    const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/

    // Sync local value with Redux value
    useEffect(() => {
        if (!reduxValue || reduxValue === "") {
            setLocalValue(defaultValue || ""); // Reset local value
            setLocalError(""); // Clear local error
            dispatch({ type: types.FORM_INPUT, value: defaultValue || "", name });
            dispatch({ type: types.FORM_ERROR, name, error: "" }); // Clear Redux error
        } else if (reduxValue !== localValue) {
            setLocalValue(reduxValue);
        }
    }, [reduxValue]);

    // // Sync local error state with Redux error state
    useEffect(() => {
        if (reduxErrorMsg !== localError) {
            setLocalError(reduxErrorMsg);
        }
    }, [reduxErrorMsg]);


    const onChange = (e) => {
        updateStore(e.target.value);
    }

    const updateStore = (value) => {
        const error = validate(value);
        setLocalValue(value);
        setLocalError(error);
        setLocalError(error)
        dispatch({ type: types.FORM_INPUT, value, name });
        dispatch({ type: types.FORM_ERROR, name, error });
    }

    const validate = (value) => {
        let error = null;
        if (required){
            if (!value || value === ""){
                error = errorMsg ? errorMsg : 'Email is required';
            }else{
                error = ""
            }
        }

        if (value && value.length > 0) {
            console.log(value);
            const patt = new RegExp(emailPattern);
            if (!patt.test(value))
                error = `Email is invalid`;
        }
        
        return error;
    }

    return (
        <div className="form-group TextInput">
            <FormControl className={`${className} ${Boolean(localError) ? 'error' : ``}`} error={Boolean(localError)} fullWidth>
                <TextField 
                    {...textProps}
                    InputLabelProps={{ shrink: true }}
                    type={type}
                    InputProps={{
                        minLength: minLength || 0,
                        maxLength: maxLength || 250,
                        startAdornment: startAdornment || null,
                        endAdornment: endAdornment || null,
                    }}
                    value={localValue || ""}
                    onChange={onChange}
                    variant='standard'
                    label={label}
                    placeholder={hintText}
                    id={name}
                />
                {localError ? <FormHelperText>{localError}</FormHelperText> : null}
            </FormControl>
        </div>
    );
};
export default EmailInput;